import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

// c_fit: full product, no padding/background added
const toThumb = (url) => {
  if (!url || !url.includes("/upload/")) return url;
  return url.replace("/upload/", "/upload/c_fit,f_auto,q_auto,w_800,h_540/");
};

export default function Gallery({ media = [] }) {
  const [isOpen,     setIsOpen]     = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [filter,     setFilter]     = useState("all");

  const filtered  = filter === "all" ? media : media.filter((m) => m.type === filter);
  const imageUrls = filtered.filter((m) => m.type === "image").map((m) => m.url);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3500,
    autoplaySpeed: 0,
    cssEase: "linear",
    swipeToSlide: true,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992,  settings: { slidesToShow: 2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div id="portfolio" className="text-center gallery-section">
      <div className="container">
        <div className="section-title">
          <h2>Products, Brands &amp; Business Showcase</h2>
          <p>
            A visual showcase of our product range, brand activities and business
            operations under the Utensy brand by Netra Bharat Industries.
          </p>
        </div>
        <div className="gallery-filter">
          {["all", "image", "video"].map((f) => (
            <button
              key={f}
              className={filter === f ? "active" : ""}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f === "image" ? "Images" : "Videos"}
            </button>
          ))}
        </div>
      </div>

      <div className="gallery-slider-wrap">
        {filtered.length > 0 ? (
          <>
            <Slider {...settings}>
              {filtered.map((item, i) => (
                <div key={i} className="gallery-slide">
                  <div
                    className="gallery-card"
                    onClick={() => {
                      if (item.type !== "video") {
                        setPhotoIndex(imageUrls.indexOf(item.url));
                        setIsOpen(true);
                      }
                    }}
                    style={{ cursor: item.type !== "video" ? "pointer" : "default" }}
                  >
                    {item.type === "video" ? (
                      <video
                        src={item.url}
                        controls
                        preload="metadata"
                        className="gallery-media"
                      />
                    ) : (
                      <img
                        src={toThumb(item.url)}
                        alt={`Utensy product ${i + 1}`}
                        loading="lazy"
                        className="gallery-media"
                      />
                    )}
                  </div>
                </div>
              ))}
            </Slider>

            {isOpen && (
              <Lightbox
                mainSrc={imageUrls[photoIndex]}
                nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
                prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
                onCloseRequest={() => setIsOpen(false)}
                onMovePrevRequest={() =>
                  setPhotoIndex((photoIndex + imageUrls.length - 1) % imageUrls.length)
                }
                onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % imageUrls.length)
                }
                reactModalStyle={{
                  overlay: { zIndex: 9999 }
                }}
              />
            )}
          </>
        ) : (
          <div className="gallery-empty">
            <i className="fa fa-image"></i>
            <p>Gallery images will appear here once uploaded.</p>
          </div>
        )}
      </div>
    </div>
  );
}
